import { RouteHandler } from 'wee-routes';
import { $setRef } from 'core/dom';
import $ from 'wee-dom';
import $fetch from 'wee-fetch';
import $events from 'wee-events';
import Cookies from 'cookies.js';

export default new RouteHandler({
    init() {
        const $container = $(':alertContainer');

        if ($container.data('enabled') && ! Cookies.get('alertClosed')) {
            $fetch({
                method: 'get',
                url: '/ajax/alert',
                json: false,
                responseType: 'text',
            }).then(({ data }) => {
                $container.append(data);
                $setRef();

                const $alertBar = $(':alertBar');
                const $navInner = $(':navInner');

                if ($alertBar.length) {
                    $navInner.height(`calc(100vh - 6.3rem - ${$alertBar.height()}px)`);
                }

                $events.on(':alertBarClose', 'click', (e) => {
                    $alertBar.hide();
                    $('html').removeClass('-has-alert');
                    $navInner.removeAttr('style');

                    Cookies.set('alertClosed', true, {
                        expires: 1,
                    });

                    e.stopPropagation();
                    e.preventDefault();
                });
            });
        }
    },
});
